import semver from 'semver';
import Dialog, { install } from './Dialog'
function plugin(app) {
    if (app.DialogInstalled) {
        return;
    }
    app.DialogInstalled = true;

    install()


    if (semver.lt(app.version, '3.0.0')) {
        Object.defineProperties(app.prototype, {
            $Dialog: {
                get: function get() {
                    return Dialog;
                }
            },
        });
    } else {
        app.config.globalProperties.$Dialog = Dialog;
    }

}

export default {
    install: plugin
}
export { Dialog }